export default __webpack_public_path__ + "02411dec3f3e2adc78b1215490713458.png";